// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import ScratchAndDentFormState from "@store/Framework/Store/Store/Components/ScratchAndDentForm/ScratchAndDentFormState";
import { SndGrades } from "@store/Framework/Types/ApiModels";
import { Draft } from "immer";

const initialState: ScratchAndDentFormState = {
    isSearching: false,
    isSubmitting: false,
    selectedProductInfo: undefined,
    originalSelectedProductInfo: undefined,
};

const actions = {
    "Store/Components/ScratchAndDentForm/BeginSetProduct": (draft: Draft<ScratchAndDentFormState>) => {
        delete draft.selectedProductInfo;
        draft.isSearching = true;
    },
    "Store/Components/ScratchAndDentForm/CompleteSetProduct": (
        draft: Draft<ScratchAndDentFormState>,
        action: { productInfo?: ProductInfo; originalProductInfo?: ProductInfo },
    ) => {
        draft.selectedProductInfo = action.productInfo;
        draft.originalSelectedProductInfo = action.originalProductInfo;
        draft.isSearching = false;
    },
    "Store/Components/ScratchAndDentForm/SetSndGrades": (
        draft: Draft<ScratchAndDentFormState>,
        action: { sndGrades: SndGrades },
    ) => {
        draft.sndGrades = action.sndGrades;
    },
    "Store/Components/ScratchAndDentForm/BeginAddProduct": (draft: Draft<ScratchAndDentFormState>) => {
        draft.isSubmitting = true;
    },
    "Store/Components/ScratchAndDentForm/CompleteAddProduct": (draft: Draft<ScratchAndDentFormState>) => {
        draft.isSubmitting = false;
    },
    "Store/Components/ScratchAndDentForm/BeginEditProduct": (draft: Draft<ScratchAndDentFormState>) => {
        draft.isSubmitting = true;
    },
    "Store/Components/ScratchAndDentForm/CompleteEditProduct": (draft: Draft<ScratchAndDentFormState>) => {
        draft.isSubmitting = false;
    },

    "Store/Components/ScratchAndDentForm/ResetProduct": () => {
        return { ...initialState };
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ScratchAndDentFormActions = Parameters<typeof reducer>[1];
export default reducer;
